import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { RoleManagementService } from '@services/role.management.service';
import { toHTML } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { GlobalToolbarConfig, MatrixOptions, Stems } from 'src/app/shared/addnewquestion';
import { CkeditorConfig, ScoringTypeEnum, QuestionSubTypeIdEnum, QuestionTypeIdEnum } from 'src/app/shared/config/questions.config';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { ItemsSubPartEditorComponent } from '../items-sub-part-editor/items-sub-part-editor.component';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';
import * as Editor from '../../../../assets/ckeditor';
import Adapter from '../ckeditorAdapter';
@Component({
  selector: 'app-items-matrix-single-choice',
  templateUrl: './items-matrix-single-choice.component.html',
  styleUrls: ['./items-matrix-single-choice.component.scss']
})
export class ItemsMatrixSingleChoiceComponent implements OnInit {
  @Output() postCreated = new EventEmitter();

  reuseProp = {
    questionuuId: 'questionuuId',
    questiondescription: 'questiondescription',
    description: 'description',
    tempStem: 'tempStem',
    tempOption: 'tempOption',
    stems: 'stems',
    options: 'options',
    correctPoints: 'correctPoints',
    itemId: 'itemId',
    penaltyPoints: 'penaltyPoints',
    minScoreIfAttempt: 'minScoreIfAttempt',
    scoringTypeExactMatch: 'scoringTypeExactMatch'
  }

  userForm: FormGroup;
  itemId: string;
  questionId: string;
  queId: any;
  // questionEditor: Editor = new Editor();
  // stemEditor: Editor = new Editor();
  // optionEditor: Editor = new Editor();
  display: boolean = false;

  isEditMode: boolean = false;
  isListMode: boolean = false;
  isQuestionAdded: boolean = false;
  validateQuestion: boolean = false;
  private routerSubscription: Subscription;
  toolbar = GlobalToolbarConfig;
  ckeditorConfig = CkeditorConfig;
  ScoringTypeEnum = ScoringTypeEnum;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;
  stemToDelete: number[] = [];
  optionToDelete: number[] = [];
  scoringType: any;
  isCkeditorLoading: boolean = true;
  optionId: any;
  stemid: any;
  QuestionScoringType: any;
  //-------- CKEditor5 Version---------
  @ViewChild("myEditor1") myEditor1: any;
  @ViewChild("myEditor2") myEditor2: any;
  @ViewChild("myEditor3") myEditor3: any;
  public Editor: any = Editor;
  optionValue: any = '';
  errorMessage;
  errorMessageStem;
  errorMessageProp;
  public uploadedFileNames = [];
  public uploadedFileOptions = [];
  QuestionImages = []
  optionImages = []
  stemImages = []
  imageId: number = 1;

  constructor(
    public roleSer: RoleManagementService,
    public sanitizer: DomSanitizer,
    private router: Router,
    public dialog: MatDialog,
    public itemservice: ItemService,
    private routerstate: ActivatedRoute,
    public questionService: QuestionService,
    private webErrorService: WebErrorService,
    private notificationService: NotificationService,
    public translate: TranslateService,
    public dialogRef: MatDialogRef<ItemsMatrixSingleChoiceComponent>
  ) {
    this.routerSubscription = this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemId = data.id;
    });

    this.questionId = sessionStorage.getItem(this.reuseProp.questionuuId);
    this.scoringType = sessionStorage.getItem('scoringTypeId');
    if (!this.questionId) {
      this.questionId = this.router.getCurrentNavigation()?.extras?.state?.questionId;
    }

    this.userForm = new FormGroup({
      ansRenderCount: new FormControl(0),
      questionOrder: new FormControl(0),
      questionSubTypeId: new FormControl(QuestionSubTypeIdEnum.Matrix),
      questionTypeId: new FormControl(QuestionTypeIdEnum.Matrix),
      questiondisplayoptions: new FormControl('Vertical'),
      active: new FormControl(true),
      autoScoring: new FormControl(false),
      allowCheckAnswer: new FormControl(false),
      shuffleOption: new FormControl(false),
      [this.reuseProp.scoringTypeExactMatch]: new FormControl('false'),
      [this.reuseProp.questiondescription]: new FormGroup({ description: new FormControl('', Validators.required), mediaURL: new FormControl([""]), file_name: new FormControl([""]) }),

      [this.reuseProp.itemId]: new FormControl(''),
      [this.reuseProp.correctPoints]: new FormControl(0),
      [this.reuseProp.stems]: new FormArray([], [Validators.required, Validators.minLength(2)]),
      [this.reuseProp.options]: new FormArray([], [Validators.required, Validators.minLength(2)]),
      [this.reuseProp.penaltyPoints]: new FormControl(0),
      [this.reuseProp.minScoreIfAttempt]: new FormControl(0,Validators.required),

      [this.reuseProp.tempStem]: new FormControl(),
      [this.reuseProp.tempOption]: new FormControl(),
      questionImages: new FormControl(''),
      optionImages: new FormControl(''),
      stemImages: new FormControl('')
    });

    this.questionService.getQuestionScoringType().subscribe(d => {this.QuestionScoringType = d.data})
  }

  get f() {
    return this.userForm.controls;
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
        this.userForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description]
        // .replace(/<img>/g, '<img width="100" height="100"');
      })
      return adapter;
    }
  }

  onReadyStem(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessageStem = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessageStem = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessageStem = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileOptions.push(res.fileName)
        this.stemImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onReadyProp(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessageProp = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessageProp = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessageProp = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileOptions.push(res.fileName)
        this.optionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  ngOnInit(): void {
    if (this.questionId) {
      this.isEditMode = true;
      const questionServiceGetSubscription: Subscription = this.questionService
        .getQuestion(this.itemId, this.questionId)
        .subscribe((resdata) => {
          this.queId = resdata.data.questionid;
          this.isQuestionAdded = true;
          this.userForm.patchValue(resdata.data);
          this.userForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.stringify(resdata.data.scoringTypeExactMatch));
          if (resdata.data.options && resdata.data.options.length) {
            resdata.data.options.forEach(element => {
              (<FormArray>this.userForm.controls[this.reuseProp.options]).push(new FormControl({ ...element, modified: true }));
            })
          };
          if (resdata.data.stems && resdata.data.stems.length) {
            resdata.data.stems.forEach(element => {
              (<FormArray>this.userForm.controls[this.reuseProp.stems]).push(new FormControl({ ...element, modified: true }));
            })
          };

          this.userForm.get(this.reuseProp.stems).updateValueAndValidity();
          questionServiceGetSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
    }
  }

  omit_special_char(event) {
    var k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 ||(k >= 48 && k <= 57) ||  k == 46);
  }

  replace2Decimall(event: any, stem){
    let value = event.target.value;
    if (event.key == '.') value = value + event.key;
    if(value == '.') value = "";

    var ponto = value.split('.').length;

    if (ponto > 2) value = value.substr(0, (value.length)-1);

    value = value.replace(/[^0-9.-]/,'');

    if (ponto == 2) value = value.substr(0,(value.indexOf('.')+3));

    stem.correctPointsforStem = parseFloat(value);
  }

  replace2Decimal(event: any, o?: any, type?: any){
    let value = event.target.value;
    if (event.key == '.') value = value + event.key;
    if(value == '.') value = "";

    var ponto = value.split('.').length;

    if (ponto > 2) value = value.substr(0, (value.length)-1);

    value = value.replace(/[^0-9.-]/,'');

    if (ponto == 2) value = value.substr(0,(value.indexOf('.')+3));

    let num = value.substr(value.length - 1);
    if (type == 'options' || type == 'edit' || type == 'new') {
      if (num != '.') {
        this.userForm.controls[this.reuseProp.correctPoints].patchValue(parseFloat('0'));
        o.points = parseFloat(value)
      }
    }
    if (type == 'minimumScore') {
      if (num != '.' && value != '') this.userForm.controls[this.reuseProp.minScoreIfAttempt].patchValue(parseFloat(value));
    }
  }

  validateInput(event, o?, type?) {
    const inputElement = event.target;
    const value = inputElement.value;

    const regex = /^\d{0,4}(\.\d{0,2})?$/;
    const inputVal = inputElement.value.split('.')
    const beforeDecimal = inputVal[0]
    const afterDecimal = inputVal[1]
    console.log('value',value)
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
      if (type == 'options' || type == 'edit' || type == 'new') {
        this.userForm.controls[this.reuseProp.correctPoints].patchValue(parseFloat('0'));
        o.points = parseFloat(value)
      }
      if(type == 'minimumScore') this.userForm.controls[this.reuseProp.minScoreIfAttempt].patchValue(parseFloat(inputElement.value));

      if(beforeDecimal.length == 5 && afterDecimal.length > 1) {
        inputElement.value = ''
        if (type == 'options' || type == 'edit' || type == 'new') {
          this.userForm.controls[this.reuseProp.correctPoints].patchValue(0);
          o.points = parseFloat(value)
        }
        if(type == 'minimumScore') this.userForm.controls[this.reuseProp.minScoreIfAttempt].patchValue(0);
      }
    }
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  validateEditorText(value: string): boolean {
    return value.length != 0;
  }

  setAndUpdateControl(controlName: string, value: any): void {
    this.userForm.get(controlName).patchValue(value);
    this.userForm.get(controlName).updateValueAndValidity();
  }

  validateAndAddStem(): void {
    this.userForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description] = this.userForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description]
    // .replace(/<img/g, '<img width="400" height="400"');
    let questionhtml = this.userForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description].trim();
    if (!questionhtml || questionhtml.length == 0) {
      this.validateQuestion = true;
      this.isQuestionAdded = false;
     } else {
      this.errorMessageStem = false;
      this.validateQuestion = false;
      this.isQuestionAdded = true;
       let newValue = this.userForm.controls[this.reuseProp.tempStem].value.replace(/&nbsp;/g,'')
      //  .replace(/<img/g, '<img width="100" height="100"').trim();
       let question1 = newValue;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();
       if (newValue.type) { newValue = toHTML(newValue); }
       if (this.validateEditorText(question1)) {
         let existingValue = this.userForm.controls[this.reuseProp.stems].value;
         if (this.isEditMode) {
           let newStem: Stems = {
             stemdescription: {
               description: newValue, mediaURL: [''], file_name: this.uploadedFileOptions
             }, correctPointsforStem: 0, matrixid: null, stemid: null, modified: false, validchoiceid: 0,
             arrangeOrderForStems: 0
           };
           if (existingValue && existingValue.length) {
             newStem = { ...newStem, stemid: existingValue[existingValue.length - 1].stemid + 1, arrangeOrderForStems: existingValue.length + 1 };
           }
           (<FormArray>this.userForm.controls[this.reuseProp.stems]).push(new FormControl(newStem));

           if (this.scoringType == ScoringTypeEnum.OnOption) {
             this.userForm.controls[this.reuseProp.options].value.forEach((d, index) => {
               d.optionScores.push({stemid: existingValue[existingValue.length - 1].stemid + 1, points: 0})
             });
           }
          //  this.userForm.value[this.reuseProp.options].forEach((element, index) => {
          //    element.optionScores.forEach((e, index) => {
          //      e.stemid = index + 1;
          //    });
          //  });

          //  this.userForm.value[this.reuseProp.stems].forEach((element, index) => { element.stemid = index + 1; });
           // this.userForm.controls[this.reuseProp.options].value.optionScores.forEach((element, index) => { element.stemid = index + 1; });

         } else {
           let newStem: Stems = {
             stemdescription: {
               description: newValue, mediaURL: [''], file_name: this.uploadedFileOptions
             }, correctPointsforStem: 0, matrixid: null, stemid: 1, modified: false, validchoiceid: 0,
             arrangeOrderForStems: 0
           };
           if (existingValue && existingValue.length) {
             newStem = { ...newStem, stemid: existingValue[existingValue.length - 1].stemid + 1 };
           }
           (<FormArray>this.userForm.controls[this.reuseProp.stems]).push(new FormControl(newStem));
         }
         this.userForm.value[this.reuseProp.stems].forEach((element, index) => {
           element.arrangeOrderForStems = index + 1;
         });
         this.setAndUpdateControl(this.reuseProp.tempStem, '');
         this.uploadedFileOptions = []
         // this.stemEditor.setContent('');
       }
     }
  }

  removeArrayItem(index: number, property: string): void {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: this.translate.instant('questions.typeOfQuestions.matrixSingleChoice.deletePopup.message') + ' ' + this.translate.instant('questions.ItemSubEditor.' + property.slice(0, -1))  + '?',
        buttonText: {
          ok: this.translate.instant('questions.typeOfQuestions.matrixSingleChoice.deletePopup.btnYes'),
          cancel: this.translate.instant('questions.typeOfQuestions.matrixSingleChoice.deletePopup.btnNo'),
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        if (property === this.reuseProp.stems) {
          if (this.userForm.controls[this.reuseProp.stems].value.length == 2) {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.matrixSingleChoice.errMsg1'), true, 'warn')
            return;
          }
          this.stemToDelete.push((<FormArray>this.userForm.get(property)).at(index).value.stemid);
          this.stemToDelete.forEach(stemId => {
            this.questionService.deleteStem(this.questionId, stemId).subscribe(() => { });
          });

          if (this.scoringType == ScoringTypeEnum.OnOption) {
            // this.stemToDelete.forEach(stemId => {
            //   this.questionService.deleteStem(this.questionId, stemId).subscribe(() => { });
            // });
            this.userForm.value.options.forEach(element => {
              element.optionScores = element.optionScores.filter(item => item.stemid !== (<FormArray>this.userForm.get(property)).at(index).value.stemid);
              // element.optionScores.pop(index);
            });
          }
        } else {
          if (this.userForm.controls[this.reuseProp.options].value.length == 2) {
            this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.matrixSingleChoice.errMsg1'), true, 'warn')
            return;
          }

          this.optionToDelete.push((<FormArray>this.userForm.get(property)).at(index).value.optionId);
          this.optionToDelete.forEach(optId => {
            this.questionService.deleteOption(this.questionId, optId).subscribe(() => { });
          });
        }
        (<FormArray>this.userForm.get(property)).removeAt(index);
        this.calculateScore();
        this.userForm.get(property).updateValueAndValidity();
      }
    })
  }

  validateAndAddOption(): void {
    let questionhtml = this.userForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description]
    // .replace(/<img/g, '<img width="100" height="100"').trim();
    if (!questionhtml || questionhtml.length == 0) {
      this.validateQuestion = true;
      this.isQuestionAdded = false;
    } else {
      this.errorMessageProp = false;
      this.validateQuestion = false;
      this.isQuestionAdded = true;
      let newValue = this.userForm.controls[this.reuseProp.tempOption].value.replace(/&nbsp;/g,'')
      // .replace(/<img/g, '<img width="100" height="100"').trim();
      let question1 = newValue;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();
      if (newValue.type) { newValue = toHTML(newValue); }
      if (this.validateEditorText(question1)) {
        let existingValue = this.userForm.controls[this.reuseProp.options].value;
        let newOpt: MatrixOptions = {
          answerDescription: { description: newValue, mediaURL: [''], file_name: this.uploadedFileOptions },
          answerValid: false, correctPoints: 0, modified: false, optionId: 1, selected: false,
          arrangeOrder: 0,
          optionScores: []
        };

        if (existingValue && existingValue.length) {
          newOpt = { ...newOpt, optionId: existingValue[existingValue.length - 1].optionId + 1, arrangeOrder: existingValue.length + 1 };
        }

        (<FormArray>this.userForm.controls[this.reuseProp.options]).push(new FormControl(newOpt));

         if (this.scoringType == ScoringTypeEnum.OnOption) {
           this.userForm.controls[this.reuseProp.options].value.forEach(d => {
            if (d.optionScores.length == 0) {
              this.userForm.controls[this.reuseProp.stems].value.forEach(dd => {
                d.optionScores.push({stemid: dd.stemid, points: 0})
              });
            }

            //  if (d.optionScores.length == 0 && existingValue && existingValue.length) {
            //    existingValue[0].optionScores.forEach(e => {
            //      d.optionScores.push({stemid: e.stemid, points: 0})
            //    })
            //  }
           });
         }

         this.userForm.value[this.reuseProp.options].forEach((element, index) => {
           element.arrangeOrder = index + 1;
         });
         this.setAndUpdateControl(this.reuseProp.tempOption, '');
         this.uploadedFileOptions = []
         // this.optionEditor.setContent('');
      }
     }

  }

  openDialog(value: any, isStem: boolean, index): void {
    const dialogSubscription = this.dialog.open(ItemsSubPartEditorComponent,
      {
        width: '950px', height: '350px', panelClass: 'option-dialog', data:
          { value: isStem ? value.stemdescription.description : value.answerDescription.description, title: isStem ? this.translate.instant('questions.ItemSubEditor.stem') : this.translate.instant('questions.ItemSubEditor.option') }
      })
      .afterClosed().subscribe((result) => {
        if (result) {
          this.itemservice.getfileName.subscribe(file => {
            if (isStem) {
              (<FormArray>this.userForm.controls[this.reuseProp.stems])
                .at(this.userForm.controls[this.reuseProp.stems].value.findIndex((d: any) => d.stemid == value.stemid))
                .setValue({ ...value, stemdescription: { description: result, mediaURL: [''],  file_name: file}
              });
              this.userForm.get(this.reuseProp.stems).updateValueAndValidity();
            }
            else {
              (<FormArray>this.userForm.controls[this.reuseProp.options])
                .at(this.userForm.controls[this.reuseProp.options].value.findIndex((d: any) => d.optionId == value.optionId))
                .setValue({ ...value, answerDescription: { description: result, mediaURL: [''], file_name: file}
                });
              this.userForm.get(this.reuseProp.options).updateValueAndValidity();
            }
          })
        }
        dialogSubscription.unsubscribe();
      });
  }

  calculateScore(): void {
    // this.setAndUpdateControl(this.reuseProp.correctPoints, (<FormArray>this.userForm.controls[this.reuseProp.stems]).value.map(d => d.correctPointsforStem).reduce((a, b) => +a + +b));
    this.userForm.get(this.reuseProp.correctPoints).patchValue(parseFloat((<FormArray>this.userForm.controls[this.reuseProp.stems]).value.map(d => d.correctPointsforStem).reduce((a, b) => +a + +b)).toFixed(2));
    this.userForm.get(this.reuseProp.correctPoints).updateValueAndValidity();
  }

  optionScoring(stem, option, value) {
    let options = this.userForm.controls[this.reuseProp.options].value
    options.forEach(element => {
      if (element.optionId === option.optionId) {
        let stemid = element.optionScores.find(d => (d.stemid == stem.stemid));
        if (stemid != '' && stemid !== undefined) {
          stemid.points = parseFloat(value);
        } else {
          element.optionScores.push({stemid: stem.stemid, points: parseInt(value)})
        }
      }
    });
  }

  back(): void {
    this.postCreated.emit('false');
    this.display = true;
    // this.questionEditor.destroy();
  }

  saveMatrixQuestion() {

    this.setAndUpdateControl(this.reuseProp.itemId, sessionStorage.getItem(this.reuseProp.itemId));
    if (this.userForm.controls[this.reuseProp.stems].value.length <= 1 || this.userForm.controls[this.reuseProp.options].value.length <= 1) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.matrixSingleChoice.errMsg1'), true, 'warn')
      return;
    }
    // this.userForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.parse(this.userForm.controls[this.reuseProp.scoringTypeExactMatch].value));

    this.userForm.value.options.forEach(ele => {
      ele.answerDescription['description'] = ele.answerDescription['description'];//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '')
    });

    this.userForm.value.stems.forEach(ele => {
      ele.stemdescription['description'] = ele.stemdescription['description'];//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '')
    });

    let question = this.userForm.value.questiondescription['description'];
    this.userForm.value.questiondescription['file_name'] = this.uploadedFileNames;
    let question1 = question;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();
    if (question1.length === 0) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.matrixSingleChoice.errMsg3'), true, 'warn')
      return;  // Used to display alert message
    }

    if (this.QuestionImages.length > 0) {
      this.QuestionImages.forEach(ele => {

        question1 = question1.replace(ele.base64, ele.uniqueId)

        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }
    this.userForm.value.questiondescription['description'] = question1;
    this.userForm.value.questionImages = this.QuestionImages;

    if (this.optionImages.length > 0) {
      this.optionImages.forEach(ele => {
        this.userForm.value.options.forEach(option => {
          option.answerDescription.description = option.answerDescription.description.replace(ele.base64, ele.uniqueId)
        })
        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }

    this.userForm.value.optionImages = this.optionImages;

    if (this.stemImages.length > 0) {
      this.stemImages.forEach(ele => {
        this.userForm.value.stems.forEach(option => {
          option.stemdescription.description = option.stemdescription.description.replace(ele.base64, ele.uniqueId)
        })
        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }

    this.userForm.value.stemImages = this.stemImages;

    if (this.scoringType == ScoringTypeEnum.OnOption) {
      this.userForm.value.questionSubTypeId = QuestionSubTypeIdEnum.scoringType_Matrix;
      this.userForm.value.questionTypeId = QuestionTypeIdEnum.Matrix_score_option;

      for (let o of this.userForm.value.options) {
        let length = 0;
        if (this.isEditMode) {
          delete o.id;
          length = o.optionScores.length;
        } else {
          length = o.optionScores.length;
        }

        // let points = o.optionScores.find(d => (d.points == 0 || Number.isNaN(d.points)));

        // if (length != this.userForm.value.stems.length || (points != undefined && (points.points == 0 || Number.isNaN(points.points)))) {
        //   this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.matrixSingleChoice.errMsg2'), true, 'warn') // Used to display alert message
        //   return;
        // }
      }
    }

    if (this.isEditMode) {
      let isCorrectPoints = this.userForm.value.stems.find(s => s.correctPointsforStem == "");
      if (isCorrectPoints) {
        this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg8'), true, 'warn')
        return;
      }
      // if (this.correctScorePoint == null && this.scoringTypeId != ScoringTypeEnum.On180360Degree) {
      //   this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg8'), true, 'warn')
      // }
      const questionServiceUpdateSubscription: Subscription = this.questionService.updateQuestion(this.userForm.value, this.itemId, this.questionId).subscribe(
        (resData) => {
          this.itemservice.editedGetItem(resData.data);
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isListMode = true;
          questionServiceUpdateSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
    else {
      const questionServicePostSubscription: Subscription = this.questionService.addQuestion(this.userForm.value, this.itemId).subscribe(
        (resData) => {
          this.isEditMode = true;
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isEditMode = true;
          this.isListMode = true;
          questionServicePostSubscription.unsubscribe()
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  //#region  [Ordering Part]
  public orderIndex: any[];

  public dragAndDropEventHandler(event: any, type) {
    // const prevIndex = this.userForm.controls[this.reuseProp.stems].value.findIndex((d) => d === event.item.data);
    this.moveItemOrder(this.userForm.controls[this.reuseProp[type]].value, event.previousIndex, event.currentIndex);
    this.assignAndCreateOrder(this.userForm.controls[this.reuseProp[type]].value, type);
    this.moveItemOrder(this.orderIndex, event.previousIndex, event.currentIndex);
    // this.recreateIndex(this.orderIndex, this.reuseProp.saveOrderProperty);
    // this.table.renderRows();
    this.saveOrderApiCall(type);


  }

  saveOrderApiCall(type) {
    let payload = [];
    if (type == 'options') {
      this.userForm.controls[this.reuseProp[type]].value.forEach((a, index) => {
        let que = {
          "optionid": a.optionId,
          "arrangeorder": index + 1
        };
        a.arrangeOrder = index + 1;
        payload.push(que);

      });
    } else {
      this.userForm.controls[this.reuseProp[type]].value.forEach((a, index) => {
        let que = {
          "questionid": this.queId,
          "stemid": a.stemid,
          "arrangeorder": index + 1
        };
        a.arrangeOrderForStems = index + 1;
        payload.push(que);

      });
    }

    this.itemservice.arrangeOrderForStemOption(this.questionId, payload, type).subscribe((data) => {
    },
    (error) => {
      this.webErrorService.handleAPIErrors(error);
    });
  }

  private assignAndCreateOrder(data: any[], type): void {
    this.orderIndex = [];

    if (type == 'options') {
      data.forEach((optionId, index) => {
        this.orderIndex.push({
          'optionId': optionId.optionId,
          'optionOrdering': index + 1
        });
      });
    }
    else {
      data.forEach((stem, index) => {
        this.orderIndex.push({
          'optionId': stem.stemid,
          'optionOrdering': index + 1
        });
      });
    }
  }

  private moveItemOrder(dataList: any[], fromIndex: number, toIndex: number): void {
    var element = dataList[fromIndex];
    dataList.splice(fromIndex, 1);
    dataList.splice(toIndex, 0, element);
  }

  private recreateIndex(dataList: any[], propertyToCreateIndex: string): void {
    dataList.forEach(item => item[propertyToCreateIndex] = dataList.indexOf(item) + 1);
  }

}
